<template>
  <div class="dropDownWrapper" :style="shouldAddCursor(list)" @click="showDropdown = !showDropdown; clickEvent()">
    {{showSelected()}}
    <img src="/clientV2/static/gfx/newArrow.svg" class="iconBtnn" v-if="list.length > 0" :style="[empty(), setImgSize()]">
    <ul :id="`dd-${uId}`" class="dropdownUl" v-if="list.length > 1" v-show="showDropdown" v-focus>
      <li v-for="(item, i) in list" @click="selectedItem(item)" :style="setWidth()">
        {{(item.label) ? item.label : item}}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'Dropdown',
    props: ['list', 'defaultValue', 'setImgWidth', 'setLiWidth', 'defaultStyle'],
    data() {
      return {
        uId: Math.ceil(Math.random() * (9999999 - 1) + 1),
        showDropdown: false,
        selected: null
      }
    },
    created() {
      if (this.defaultValue) {
        this.selected = this.defaultValue
      }
      this.$root.$on('dropdownClick', (uId) => {
        if (uId != this.uId) {
          this.showDropdown = false
        }
      })
    },
    directives: {
      focus: {
        bind: function (el, binding, vnode) {
          document.addEventListener('click', function (e) {
            let clickedElem = false
            if (e.path) {
              e.path.forEach(element => {
                if (element.classList && element.classList.contains('dropDownWrapper')) {
                  clickedElem = true
                }
              })
            }

            if (clickedElem === false) {
              vnode.context.showDropdown = false
            }
          }, true)
        }
      }
    },
    methods: {
      showSelected() {
        if (this.selected) return this.selected
        if (this.list && this.list[0] && this.list[0].label) return this.list[0].label
        if (this.list && this.list[0] && !this.list[0].label) return this.list[0]
      },
      setWidth() {
        if (this.setLiWidth) {
          return {width: `${this.setLiWidth}px`}
        }
      },
      setImgSize() {
        if (this.setImgWidth) {
          return {width: `${this.setImgWidth}px`, left: '1px'}
        }
      },
      empty() {
          if (this.selected === null && this.defaultStyle === undefined) {
            return {position: 'relative', top: '3px', right: '73px'}
          }
      },
      selectedItem(item) {
        this.selected = item.label
        this.$emit('selected', item)
      },
      clickEvent: function () {
        this.$emit('dropdownClick', this.uId)
      },
      shouldAddCursor: function (list) {
        if (list.length > 1) return {cursor: 'pointer'}
        else {
        }
      },
      setDisplayValue: function () {
        if (this.defaultValue) {
          this.selected = this.defaultValue
        }
      }
    }
  }
</script>

<style scoped lang="less">
@import "../../assets/css/style.less";

  .dropDownWrapper {
    position: relative;
    display: block;
    img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 10px;
      width: 15px;
    }
  }

  .dropdownUl {
    position: absolute;
    right: -11px;
    top: 28px;
    border: @border;
    box-shadow: 2px 2px 16px 0 hsla(0, 0%, 6%, .15);
    z-index: 666666;
    background: #fff;
    padding: 0;
    margin: 0;
    min-width: 110px;
    li {
      list-style: none;
      padding: 5px;
      border-bottom: @borderBottom;
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/uiDropdown.vue